import { useSearchParams } from 'next/navigation';
import { z } from 'zod';

export const useTypedRouter = <T extends z.Schema>(
  schema: T,
): { query: z.infer<typeof schema> } => {
  const searchParams = useSearchParams();
  const params: Record<string, string> = {};

  searchParams.forEach((value, key) => {
    params[key] = value;
  });

  return {
    query: schema.parse(params),
  };
};
